

export class User {
    constructor(
        public id: number, 
        public email: string, 
        public display_name: string, 
        public first_name: string,
        public last_name: string, 
        public role: string,
        public title: string, 
        public organization: string,
        public modules: string
    ) { }
 }
   
 export class UserSecret {
    constructor(
        public id: number,
        public email: string,
        public password: string,
        public display_name: string,
        public first_name: string,
        public last_name: string,
        public role: string,
        public title: string,
        public organization: string,
        public modules: string
    ) { }
}

export class Role {
    constructor(
        public id: number,
        public name: string
       
    ) { }
}
export class Organization {
    constructor(
        public id: number,
        public name: string
       
    ) { }
}

export class Module {
    constructor(
        public id: number,
        public name: string
    ) { 
        
    }
}



// WEBPACK FOOTER //
// ./src/app/home-page/user/user.model.ts